import _ from 'lodash'
import React from 'react'

export const Highlighted = ({ text = '', highlight = '' }) => {
  if (!highlight.trim()) {
    return <span>{text}</span>
  }
  const regex = new RegExp(`(${_.escapeRegExp(highlight)})`, 'gi')
  const parts = text.split(regex)
  return (
    <span>
      {parts
        .filter(part => part)
        .map((part, i) => {
          if (regex.test(part)) {
            return (
              <b key={i} style={{ background: 'var(--bs-yellow)' }}>
                {part}
              </b>
            )
          }

          return <span key={i}>{part}</span>
        })}
    </span>
  )
}
